import api from "app/lib/api";
import {
  DEFAULT_SURGERY_PROCEDURE_ID,
  SURGERY_PROCEDURE_MAP,
} from "app/store/dashboard/surgery_types_procedures/constants/procedures";
import {
  isFilterAtDefault,
  resolveFilterValue,
} from "app/store/dashboard/surgery_types_procedures/utils/filterValues";
import * as fileDownload from "js-file-download";
import endpoints from "static/endpoints";
import { getFormattedDateTime } from "utils/date";

export const fetchSurgeryReport = async ({ procedureId, procedureFilters }) => {
  let url = endpoints.dashboard.surgeryTypes;
  const params = [];
  const activeProcedure =
    SURGERY_PROCEDURE_MAP[procedureId] ||
    SURGERY_PROCEDURE_MAP[DEFAULT_SURGERY_PROCEDURE_ID];

  if (procedureId) {
    params.push(`procedureId=${procedureId}`);
  }

  activeProcedure.filters.forEach((filter) => {
    const value = resolveFilterValue(filter, procedureFilters);
    const isEmptyRange =
      filter.type === "range" && isFilterAtDefault(filter, value);

    if (isEmptyRange || value.length === 0) {
      return;
    }

    if (Array.isArray(value)) {
      value.forEach((item) => params.push(`${filter.queryParam}[]=${item}`));
      return;
    }

    params.push(`${filter.queryParam}=${value}`);
  });

  if (params.length > 0) {
    const queryString = params.join("&");
    url += "?" + queryString;
  }

  await api
    .get(url, { responseType: "blob" })
    .then((response) => {
      const reportPrefix = activeProcedure.reportPrefix;

      fileDownload(
        response.data,
        `${reportPrefix}-report-${getFormattedDateTime()}.xlsx`
      );
    })
    .catch((error) => {
      return Promise.reject(error);
    });

  return;
};
